<div class="flex flex-col gap-4">
  <pl-loader *ngIf="isLoading()" />

  <ng-container *ngIf="!isLoading()">
    <p class="text-lg">
      {{
        (friendsSurveyStatus().length === 0
          ? 'profile.friends_survey_status.friends_survey_not_sent'
          : 'profile.friends_survey_status.intro_text'
        ) | translate
      }}
    </p>

    <pl-profile-single-friend-status *ngFor="let status of friendsSurveyStatus()" [status]="status" />
  </ng-container>
</div>
